// Separa un string entregado ("correo:contraseña perfil N", "correo:contraseña
// http://host:puerto/ dispositivo N" para IPTV, o texto libre sin estructura)
// en sus partes. Compartido entre Store.jsx (historial de compras / copiado)
// y Reportes.jsx (autocompletar correo/contraseña al reportar).
export function parseDelivered(d) {
  const original = d.trim();
  // Etiqueta final "perfil N" o "dispositivo N" (IPTV usa "dispositivo").
  const tagMatch = original.match(/\b(perfil|dispositivo)\s+(\d+)\s*$/i);
  let rest = tagMatch ? original.slice(0, tagMatch.index).trim() : original;
  // URL al final (IPTV: "correo:contra http://host:puerto/") -- se separa
  // antes de buscar el ":" de correo/contra, si no el ":" del puerto
  // ("http://...:8443") se confundía con el de la contraseña.
  const urlMatch = rest.match(/(?:^|\s)(\S+:\/\/\S+)\s*$/);
  const url = urlMatch ? urlMatch[1] : null;
  if (urlMatch) rest = rest.slice(0, urlMatch.index).trim();

  const idx = rest.indexOf(":");
  if (idx < 0) return { texto: original };
  return {
    correo: rest.slice(0, idx).trim(),
    contrasena: rest.slice(idx + 1).trim(),
    url,
    perfil: tagMatch && tagMatch[1].toLowerCase() === "perfil" ? tagMatch[2] : null,
    dispositivo: tagMatch && tagMatch[1].toLowerCase() === "dispositivo" ? tagMatch[2] : null,
  };
}

// PIN del perfil para Netflix y Disney -- se deriva del número de perfil, no
// se guarda en el stock: perfil N -> PIN N*1010 (perfil 1 -> 1010, perfil 2 ->
// 2020, ...). Netflix llega hasta el perfil 5, Disney hasta el perfil 7;
// fuera de ese rango (o cualquier otro servicio) no se muestra PIN.
export function profilePin(productName, perfil) {
  const n = Number(perfil);
  if (!n || n < 1) return null;
  const name = (productName || "").toLowerCase();
  if (name.includes("netflix") && n <= 5) return String(n * 1010);
  if (name.includes("disney") && n <= 7) return String(n * 1010);
  return null;
}
